function urlToQueryKey(url) {
  return url.split('/');
}

export { urlToQueryKey };
